import enquire from 'enquire.js';

class M100 {
    constructor(element) {
        const opener = element.querySelector('.table-filter .opener');
        const tbody = element.querySelector('tbody');
        const $tbody = $(tbody);
        const $tbodyClone = $tbody.clone(true, true);
        const $tbodyNew = $tbodyClone.clone(true, true);
        const rows = Array.prototype.slice.call(
            element.querySelectorAll('.m100-table-body tr')
        );
        const checkboxes = Array.prototype.slice.call(
            element.querySelectorAll('.m100-filter [type="checkbox"]')
        );
        const btnClear = element.querySelector('.m100-clear-filter');
        const btnClose = element.querySelector('.m100-close-filter');
        const btnExpand = element.querySelector('.table-expand[aria-controls]');

        // eslint-disable-next-line no-undef
        enquire.register('screen and (max-width:1023px)', {
            match: () => {
                this.initM100Slider(element, $tbody);
            },
            unmatch: () => {
                $tbody.slick('unslick');
            },
        });

        opener.addEventListener('click', (e) => {
            e.preventDefault();
            e.currentTarget.parentElement.classList.toggle('active');
        });

        checkboxes.forEach((element) => {
            element.addEventListener('change', (event) => {
                const values = [];
                const titles = [];
                if ('all' === event.currentTarget.name) {
                    checkboxes.forEach((item, index) => {
                        if (0 < index) {
                            // eslint-disable-next-line no-param-reassign
                            item.checked = false;
                        }
                    });
                } else {
                    checkboxes[0].checked = false;
                }
                const isMobile = window.matchMedia('(max-width: 1023px)').matches;
                checkboxes.forEach((item) => {
                    if (item.checked) {
                        values.push(item.name);
                        titles.push(item.dataset.value);
                    }
                });
                if (0 === values.length) {
                    checkboxes[0].checked = true;
                    values.push('all');
                    titles.push('All categories');
                }
                opener.innerText = titles.join(', ');
                if (1 === values.length && 'all' === values[0]) {
                    rows.forEach((row) => {
                        row.style.removeProperty('display');
                    });
                    if (isMobile) {
                        $tbody.slick('unslick');
                        $tbody.empty();
                        $tbody.append($tbodyNew.clone().find('tr'));
                        this.initM100Slider(element, $tbody);
                    }
                } else {
                    rows.forEach((row) => {
                        if (-1 !== values.indexOf(row.dataset.filter)) {
                            row.style.removeProperty('display');
                        } else {
                            // eslint-disable-next-line no-param-reassign
                            row.style.display = 'none';
                        }
                    });
                    if (isMobile) {
                        let slickFilter = '';
                        values.forEach((item, itemId) => {
                            slickFilter += 0 === itemId ? `.${item}` : `, .${item}`;
                        });
                        $tbody.slick('unslick');
                        $tbody.empty();
                        const $find = $tbodyNew.clone().find(slickFilter);
                        $tbody.append($find);
                        this.initM100Slider(element, $tbody);
                    }
                }
                let activeRows = 0;
                rows.forEach((row) => {
                    if ('none' !== row.style.display) {
                        activeRows += 1;
                    }
                });

                if (btnExpand) {
                    if (10 > activeRows) {
                        btnExpand.style.display = 'none';
                    } else {
                        btnExpand.style.removeProperty('display');
                    }
                }
            });
        });
        btnClear.addEventListener('click', (e) => {
            e.preventDefault();
            checkboxes.forEach((item, index) => {
                // eslint-disable-next-line no-param-reassign
                item.checked = 0 === index;
            });
            rows.forEach((row) => {
                row.style.removeProperty('display');
            });
            if (window.matchMedia('(max-width: 1023px)').matches) {
                $tbody.slick('unslick');
                $tbody.empty();
                $tbody.append($tbodyNew.clone().find('tr'));
                this.initM100Slider(table, $tbody);
            }
            opener.innerText = 'All categories';
        });
        btnClose.addEventListener('click', (e) => {
            e.preventDefault();
            e.currentTarget.closest('.table-filter').classList.remove('active');
        });

        if (btnExpand) {
            btnExpand.addEventListener('click', (e) => {
                e.preventDefault();
                const textWrap = document.getElementById(
                    btnExpand.getAttribute('aria-controls')
                );
                const isExpanded = 'true' === textWrap.getAttribute('aria-expanded');
                if (!isExpanded) {
                    textWrap.setAttribute('aria-expanded', 'true');
                } else {
                    textWrap.setAttribute('aria-expanded', 'false');
                }
            });
        }
    }

     initM100Slider(parent, element) {
        element.slick({
            mobileFirst: true,
            rows: 10,
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            appendArrows: parent.querySelector('.nav-table'),
            appendDots: parent.querySelector('.nav-table'),
            adaptiveHeight: true,
        });
    }

    m100table() {

    };
}

export default M100